export default function nextTick(fn: Function) {
  setTimeout(fn);
}
